import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';

class Keynote1 extends Component {

    componentDidMount = () => {
        // console.log(this.props)
    }


  render() {
    return (
      <div className="r_container">
        <div className="home">
          <div className="new_banner">
            <div className="banner_content">
              <h1>CSCE 2025</h1>
              <h6>The 2025 World Congress in</h6>
              <h6>Computer Science, Computer Engineering, & Applied Computing (CSCE)</h6>
              <h6>July 21-24, 2025, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>


          <div className="page_content">
            <h4 className="par_header">Keynotes/Invited Lectures</h4>
            <br />
            <div style={{textAlign: "center"}}>
            <b>Empowering Cyber Defense: The UCS Ecosystem of Data,
Tools, and Awareness</b> <br/>
Dr. Arash Habibi Lashkari <br/>
Canada Research Chair and Associate Professor in Cybersecurity<br/>
Founder and Director of the Behavior-Centric Cybersecurity Center (BCCC)<br/>
Co-founder and Director of the Cybersecurity Cartoon Award (CSCA)<br/>
York University, Toronto, Canada<br/>
            </div>

            <h6 className="par_header">Abstract:</h6>
            <div className="par">
            Data has become the cornerstone of intelligent, proactive cybersecurity in today's threat landscape. This talk explores how high-quality, purpose-built datasets fuel the development of AI-powered threat detection, classification, and response systems. Drawing on the open-access resources of the Understanding Cybersecurity Series (UCS) developed at York University’s Behaviour-Centric Cybersecurity Center (BCCC), we will showcase the design and application of novel cybersecurity datasets and analyzers, including encrypted traffic, memory snapshots, and logs, crafted to train and evaluate machine learning models in real-world scenarios. We will also highlight tools like NTLFlowLyzer, VolMemLyzer, and SCsVulLyzer, which support advanced profiling and zero-day threat detection. By bridging data engineering, explainable AI, and community access, UCS provides a unique platform for researchers, educators, and industry to advance threat intelligence capabilities. The session will conclude with insights into best practices for dataset development and an open call for collaboration across the cybersecurity ecosystem.
            </div>

            <h6 className="par_header">Speaker's Biography:</h6>
            <div className="par">
            Dr. Arash Habibi Lashkari, an Associate Professor and Canada Research Chair (CRC) in Cybersecurity, is the founder and director of the Behaviour-Centric Cybersecurity Center (BCCC) as well as a co-founder of the Cybersecurity Cartoon Award (CSCA), bringing over 28 years of research and teaching expertise. Recognized for his achievements, he has garnered 15 awards in international computer security competitions and has been acknowledged as one of Canada's Top 150 Researchers in 2017. He has an impressive publication record of 11 books and over 120 academic articles and addresses various cybersecurity topics. His work focuses on developing vulnerability detection technology to protect network systems from cyberattacks, leveraging his extensive experience in network, software, and computer security within industry and development contexts.
            <br/> <br/>
            <div style={{textAlign: "center"}}>
                <img src="/static/Habibi.jpg" height="300px" style={{padding:"5px"}} alt=""/>
            </div>
            </div>
          </div>


        </div>
      </div>
    );
  }
}

export default Keynote1;